import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { store as RMStore, actions as RMActions } from '../flux/glob';

import { DirsTree } from '../../../../pdc-platform/src/tsx/DirsTree';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

export default class DirResourceTree extends React.Component<
    {
        options: {
            root_dirid;
            instanceId;
        };

        setConfirmValueGetter(getter: () => any);
        unsetConfirmValueGetter();

        glob: IGlob;
    },
    {
        selectedDirId;
        RMState;
    }
> {
    constructor(props) {
        super(props);

        this.state = _.extend(this.getState(), {
            selectedDirId: this.props.options.root_dirid
        });
    }

    private getState() {
        const RMState = RMStore.getInstanceState(this.props.options.instanceId);
        return {
            RMState
        };
    }

    componentDidMount() {
        RMStore.addChangeListener(this._onChange);
    }

    private getConfirmValue = () => {
        return this.state.selectedDirId;
    };

    componentWillMount() {
        var obj = this.props.setConfirmValueGetter(this.getConfirmValue);
    }

    componentWillUnmount() {
        RMStore.removeChangeListener(this._onChange);
        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    _onChange = () => {
        this.setState(this.getState());
    };

    private handleDirSelect = (instanceId, dirid) => {
        this.setState(
            _.extend(this.state, {
                selectedDirId: dirid
            })
        );
    };

    render() {
        if (
            this.state &&
            this.state.RMState &&
            this.state.RMState.resourceTreeRootDirId &&
            this.state.RMState.resourceTreeRootDirId > 0
        ) {
            let root_dirid: number = this.state.RMState.resourceTreeRootDirId;

            let instanceId = 'resource-tree-popup' + root_dirid;

            return (
                <div>
                    <DirsTree
                        id={instanceId}
                        rootId={root_dirid}
                        rootName={'Resources'}
                        select={this.state.selectedDirId}
                        onSelect={(id) => {
                            this.handleDirSelect(instanceId, id);
                        }}
                        glob={this.props.glob}
                    />
                </div>
            );
        } else {
            return <div>{'No Resource Tree Root defined'}</div>;
        }
    }
}
